import { render, staticRenderFns } from "./ocrResultConf.vue?vue&type=template&id=0ef5a701&"
import script from "./ocrResultConf.vue?vue&type=script&lang=js&"
export * from "./ocrResultConf.vue?vue&type=script&lang=js&"
import style0 from "./ocrResultConf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports